var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { getUserAnalytics } from './getUserAnalytics';
export var addUserAnalyticsMutation = function () { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input)\n        @rest(type: \"UserAnalytics\", path: \"/user-analytics\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "], ["\n    mutation addUserAnalytics($input: REST!) {\n      addedUserAnalytics(input: $input)\n        @rest(type: \"UserAnalytics\", path: \"/user-analytics\", method: \"POST\", endpoint: \"command\") {\n        id\n      }\n    }\n  "]))),
}); };
export var addUserAnalyticsVariables = function (input, skipRefetch) { return ({
    variables: {
        input: input,
    },
    refetchQueries: input.type === 'videoPlaybackEnded' && !skipRefetch ? [getUserAnalytics()] : [],
}); };
export var ADD_USER_ANALYTICS_MUTATION = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation addUserAnalytics($input: REST!) {\n    addedUserAnalytics(input: $input)\n      @rest(type: \"UserAnalytics\", path: \"/user-analytics\", method: \"POST\", endpoint: \"command\") {\n      id\n    }\n  }\n"], ["\n  mutation addUserAnalytics($input: REST!) {\n    addedUserAnalytics(input: $input)\n      @rest(type: \"UserAnalytics\", path: \"/user-analytics\", method: \"POST\", endpoint: \"command\") {\n      id\n    }\n  }\n"])));
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/gql/addUserAnalytics.ts
// module id = 756
// module chunks = 81